<template>
  <div class="featured-book-stats">
    <div class="featured-book-stats__reading-time">
      <sprite id="app/time" class="featured-book-stats__reading-time-icon" />
      {{ book.minutesToRead }} {{ $t("min") }}
    </div>

    <div class="featured-book-stats__audio-available" v-if="book.isAudio">
      <sprite id="app/audio" class="featured-book-stats__audio-available-icon" />

      {{ $t("audioIsAvailable") }}
    </div>
  </div>
</template>

<script>
import Sprite from "@/shared/sprite"

export const messages = {
  en: {
    min: "min",
    reads: "reads",
    audioIsAvailable: "Audio and text available"
  },
  de: {
    min: "min",
    reads: "reads",
    audioIsAvailable: "Zum Lesen & Anhören"
  },
  es: {
    min: "min",
    reads: "reads",
    audioIsAvailable: "Audio disponible"
  }
}

export default {
  name: "FeaturedBookStats",
  components: {
    Sprite
  },
  props: {
    book: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  i18n: { messages }
}
</script>

<style lang="scss">
.featured-book-stats {
  $root: &;

  @include font-family(sans-serif);

  &__audio-available {
    display: flex;
    align-items: center;

    margin-bottom: $spacing-8;
  }

  &__audio-available-icon {
    width: $spacing-16;
    height: $spacing-16;
    margin-right: $spacing-8;
  }

  &__reading-time {
    display: flex;
    align-items: center;

    margin-bottom: $spacing-8;
  }

  &__reading-time-icon {
    width: $spacing-16;
    height: $spacing-16;
    margin-right: $spacing-8;
  }

  &__reads-count {
    display: flex;
    align-items: center;

    margin-bottom: $spacing-8;
  }

  &__reads-count-icon {
    width: $spacing-16;
    height: $spacing-16;
    margin-right: $spacing-8;
  }
}
</style>
